const select = 'id,isActive,type,reportType,token';
const expand = {
  process: { select: 'name' },
  processInstance: { select: 'name' },
  dynamicEntity: { select: 'displayName' },
};

export default {
  paged: {
    select: `${select},processId,processInstanceId,dynamicEntityId`,
    searchSelect: ['id', 'isActive', 'token'],
    expand,
  },
  item: {
    select: 'id,isActive,type,reportType',
  },
  itemDetail: {
    select: `${select},created`,
    expand: {
      ...expand,
      userCreator: { select: 'fullName' },
    },
  },
};
